import React from 'react';
import RemoteDevicesPage from './RemoteDevicesPage';
import { connect } from 'react-redux';
import Backend from '../../../Layouts/Backend';
import Loading from '../../../Helpers/Loading';
import { configureActions } from '../../../../actions/configure.action';
import helper from '../../../../utils/helper';
import lookupActions from '../../../../actions/lookup.actions';
import { bindActionCreators } from 'redux';

class RemoteDevices extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      remoteDevices: [],
      departments: [],
      loading: false,
      errors: '',
      deptId: undefined,
      openModal: false,
      selectedRow: null,
    };
    this.columns = [
      {
        dataField: 'model',
        text: 'Model',
        sort: true,
      },
      {
        dataField: 'serialNo',
        text: 'Serial Number',
        sort: true,
      },
      {
        dataField: 'sensorCount',
        text: 'Sensor Count',
        sort: true,
      },
      {
        dataField: 'revision',
        text: 'Revision',
        sort: true,
      },
      {
        dataField: 'description',
        text: 'Description',
        sort: true,
      },
      {
        dataField: 'hwRevision',
        text: 'HW Revision',
        sort: true,
      },
      {
        dataField: 'ipaddress',
        text: 'IP Address',
        headerStyle: { textAlign: 'center' },
        align: 'center',
        sort: true,
      },
      {
        dataField: 'messageReceivedDate',
        text: 'Last Message',
        sort: true,
        isDateTime: true,
        headerStyle: { width: 150 },
      },
      {
        dataField: 'statusId',
        text: 'Status',
        sort: true,
        formatter: this.statusFormatter,
        filterValue: this.statusFormatter,
        csvFormatter: this.statusFormatter,
      },
      {
        dataField: 'sensorPollRate',
        text: 'Normal Update',
        sort: true,
      },
      {
        dataField: 'alarmUpdate',
        text: 'Alarm Update',
        sort: true,
      },
      {
        dataField: 'mktActivationEnergy',
        text: 'MKT Activation Energy',
        sort: true,
      },
      {
        dataField: 'active',
        text: 'Active',
        headerStyle: { width: 70, textAlign: 'center' },
        align: 'center',
        sort: true,
      },
      {
        dataField: 'audible',
        text: 'Beeper',
        headerStyle: { width: 70, textAlign: 'center' },
        align: 'center',
        sort: true,
      },
    ];
    this.defaultSorted = [
      {
        dataField: 'serialNo',
        order: 'desc',
      },
    ];
    this.ctxMenuOptions = [
      [
        {
          name: 'Edit remote device',
          action: (row, rowIndex) => {
            this.props.history.push(
              `/configure/remote-devices/edit-remote-device/${row.id}`,
            );
          },
        },
        {
          name: 'Delete remote device',
          action: (row, rowIndex) => {
            this.setState({ openModal: true, selectedRow: row });
          },
        },
      ],
    ];
  }

  statusFormatter = (cell) => {
    let text;
    switch (cell) {
      case 0:
        text = 'OK';
        break;
      case 7:
        text = 'Comm. Error';
        break;
      default:
        text = 'Error';
        break;
    }
    return text;
  };

  static getDerivedStateFromProps(nextProps, prevState) {
    let state = {};
    if (nextProps.configure.remoteDevices !== prevState.remoteDevices) {
      state.remoteDevices = nextProps.configure.remoteDevices;
    }
    if (nextProps.lookup.departments !== prevState.departments) {
      state.departments = nextProps.lookup.departments;
    }
    // if (nextProps.configure.areas !== prevState.areas) {
    //   state.areas = nextProps.configure.areas;
    // }
    // if (!prevState.errors.includes(nextProps.configure.getAreasError)) {
    //   state.errors.push(nextProps.configure.getAreasError);
    // }
    state.errors = helper.centralizeError([
      nextProps.configure.errors,
      nextProps.lookup.errors,
    ]);
    if (nextProps.configure.loading !== prevState.loading) {
      state.loading = nextProps.configure.loading;
    }
    return Object.keys(state).length ? state : null;
  }

  async componentDidMount() {
    await this.props.lookupActions.getDepartments().then((resp) => {
      let deptId = helper.parseQueryString(this.props.location.search).deptId;
      if (deptId) {
      } else {
        deptId = helper.getUserDepartment(resp).deptId;
      }
      this.setState({ deptId: parseInt(deptId) }, async () => {
        await this.props.configureActions.getRDsByDept(deptId);
        this.props.history.replace(
          `/configure/remote-devices?deptId=${deptId}`,
        );
      });
    });
  }
  componentDidUpdate(prevProps, prevState) {
    const propsDept = helper.parseQueryString(
      this.props.location.search,
    ).deptId;
    if (propsDept && parseInt(propsDept) !== this.state.deptId) {
      this.setState(
        { deptId: parseInt(propsDept) },
        async () =>
          await this.props.configureActions.getRDsByDept(parseInt(propsDept)),
      );
    }
  }
  // onChangeDept = (deptId) => {
  //   this.setState(
  //     { deptId },
  //     async () => await this.props.configureActions.getRDsByDept(deptId),
  //   );
  // };
  onCancel = () => {
    this.setState({ openModal: false, selectedRow: null });
  };

  onDeleteRemoteDevice = () => {
    const { selectedRow } = this.state;
    this.setState(
      { openModal: false },
      async () =>
        await this.props.configureActions
          .deleteRemoteDevice(selectedRow.id)
          .then(
            async () =>
              await this.props.configureActions.getRDsByDept(this.state.deptId),
          ),
    );
  };
  render() {
    if (this.state.loading) {
      return (
        <Backend>
          <Loading />
        </Backend>
      );
    }
    return (
      <RemoteDevicesPage
        {...this.state}
        onChangeDept={(deptId) =>
          this.props.history.push(`/configure/remote-devices?deptId=${deptId}`)
        }
        datagridProps={{
          columns: this.columns,
          defaultSorted: this.defaultSorted,
        }}
        ctxMenuOptions={this.ctxMenuOptions}
        onCancel={this.onCancel}
        onDeleteRemoteDevice={this.onDeleteRemoteDevice}
      />
    );
  }
}

function mapStateToProps(state) {
  return {
    configure: state.configure,
    lookup: state.lookup,
  };
}
function mapDispatchToProps(dispatch) {
  return {
    lookupActions: bindActionCreators(
      Object.assign({}, lookupActions),
      dispatch,
    ),
    configureActions: bindActionCreators(
      Object.assign({}, configureActions),
      dispatch,
    ),
  };
}
export default connect(mapStateToProps, mapDispatchToProps)(RemoteDevices);
